/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
// Formik and Yup

// / import MDCard from "components/MDCard";
import TextError from "utils/TextError";

import CloseIcon from "@mui/icons-material/Close";
import DatePicker from "react-datepicker";

// Dashboard example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

import Config from "../../../config/index";
// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";
import "react-datepicker/dist/react-datepicker.css";

// Notification
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// Functions from store
import {
  createDynamicColumn,
  getAcn,
  getAgeingParameter,
  getCreatedActivity,
  getDocumentType,
  getDynamicColumn,
  getFgReport,
  getFgReportDownload,
  getMovementByDocumentId,
  getPicklistAgeing,
  getSubModulesByRoleId,
} from "../../../store";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { CSVLink } from "react-csv";

// Cookies
import { Backdrop, CircularProgress, IconButton, Modal } from "@mui/material";
import Collapse from "@mui/material/Collapse";
import DownloadDataButton from "components/standardized-components/DownloadDataButton";
import Cookies from "universal-cookie";

import Alert from "@mui/material/Alert";

import MDCard from "components/MDCard";
import { addDays, addMinutes, format, subDays } from "date-fns";

const desLength = Config.descriptionLength;
const cookies = new Cookies();

const FGRelatedReport = ({
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getCreatedActivity,
  getMovementByDocReducer,
  getAcnReducer,
  getDocumentType,

  createDynamicColumn,
  getDynamicColumn,
  getFGTypeReducer,
  getAgeingParameter,
  getFgReportReducer,
  getFGModalReducer,
  getMovementByDocumentId,
  getAcn,
  getFgReportDownloadReducer,
  getFgReport,
  getFgReportDownload,
  getPicklistAgeing,
  getDynamicColumnReducer,
}) => {
  let loginDetails = cookies.get("loginDetailsForWMS");
  const styleForColumnReorder = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 380,
    color: "black",
    // border: "2px solid #000",
    boxShadow: 24,
    p: 2,
    pt: 3,
  };

  let jwtToken = loginDetails?.jwt;
  let roleId = loginDetails.data.roleId;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  useEffect(() => {
    getAcn(jwtToken);
  }, []);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: 350, sm: 400, md: 520 },
    maxHeight: "90vh",
    // Remove or adjust overflowY
    // overflowY: "visible",
    boxShadow: 24,
    p: 2,
    bgcolor: "background.paper",
    borderRadius: 3,
    zIndex: 1400,
  };
  useEffect(() => {
    getDocumentType(jwtToken);
  }, []);

  useEffect(() => {
    getAgeingParameter(jwtToken);
  }, []);

  const [documentTypeSelected, setDocumentTypeSelected] = useState("");
  const [movementTypeSelected, setMovementTypeSelected] = useState("");
  const [parameterSelected, setparameterSelected] = useState("");

  useEffect(() => {
    getMovementByDocumentId(
      documentTypeSelected ? documentTypeSelected?.value : "",
      jwtToken,
    );
  }, [documentTypeSelected]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  let fgRelatedReportModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "b06fcaa4-4054-4914-b1fa-77c7f0899863",
  );

  let viewAccess = fgRelatedReportModule
    ? fgRelatedReportModule.actionId.includes(
        "9e9ee2b1-895b-4d63-a28d-bc84b28ed838",
      )
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };
  const [refresh, setRefresh] = useState("");
  // setTimeout(() => {
  //   setRefresh(!refresh);
  // }, 60000);

  useEffect(() => {
    getFgReport(pageNo, rowsPerPage, searchObject, jwtToken);
  }, [pageNo, rowsPerPage, searchObject, refresh]);

  const statusOptions = [
    {
      label: "All Status",
      value: "",
    },
    {
      label: "In Progress",
      value: 0,
    },
    {
      label: "Created",
      value: 1,
    },
    {
      label: "In Yard",
      value: 2,
    },
    {
      label: "Dispatched",
      value: 3,
    },
  ];
  const navigate = useNavigate();

  const [state, setState] = useState({
    columns: [
      { Header: "FG Model", accessor: "fgModelCode" },
      { Header: "FG Type", accessor: "fgType" },
      { Header: "Vin Number", accessor: "vin" },
      //   { Header: "item Code", accessor: "desciption" },
      {
        Header: "Description",
        accessor: "desciption",
        width: 320,
        alig: "left",
      },
      //   { Header: "Date Time", accessor: "Date Time" },
      { Header: "Serial Number", accessor: "serialNumber" },
      { Header: "Work Order", accessor: "workOrder" },
      {
        Header: "Status",
        accessor: "status",
        searchType: "select",
        selectOptions: statusOptions,
        placeholder: "All Status",
      },
      {
        Header: "Created Date",

        accessor: "startDate",
        align: "left",
        searchType: "date",
        Cell: ({ value }) => {
          return value
            ? format(
                addMinutes(
                  new Date(value),
                  new Date(value).getTimezoneOffset(),
                ),
                "dd/MM/yyyy hh:mm aaa",
              )
            : "";
        },
      },
    ],
    rows: [],
  });
  const { columns, rows } = state;

  const [loading, setLoading] = useState(true);

  const [selectedDateRange, setSelectedDateRange] = useState("");

  const handleDateRangeChange = (selected) => {
    setSelectedDateRange(selected);
  };

  const [customDate, setCustomDate] = useState("");
  const sevenDays = subDays(new Date(), 7).toISOString();
  const thityDays = subDays(new Date(), 30).toISOString();
  const nintyDays = subDays(new Date(), 90).toISOString();

  const [dateRange, setDateRange] = useState([null, null]);

  const [startDate, endDate] = dateRange;

  // useEffect(() => {
  //   getDateRange(jwtToken);
  // }, []);

  useEffect(() => {
    if (selectedDateRange.value == 7) {
      setCustomDate(sevenDays);
    }
    if (selectedDateRange.value == 30) {
      setCustomDate(thityDays);
    }
    if (selectedDateRange.value == 90) {
      setCustomDate(nintyDays);
    }
  }, [selectedDateRange]);

  const [createCircularModal, setCreateCircularModal] = useState(false);
  const handleCreateCircularModal = () => {
    setTimeout(() => {
      setCreateCircularModal(true);
    }, 500);
    setDownload("");
    setCustomDate("");
    setSelectedDateRange("");
    setDateRange([null, null]);
    // formik.setValues(initialValues);
    // formik.setTouched({});
    // formik.setErrors({});
  };
  const handleCreateCloseCircularModal = () => {
    setTimeout(() => {
      setCreateCircularModal(false);
    }, 500);
    setDownload("");
    setCustomDate("");
    setSelectedDateRange("");
    setDateRange([null, null]);
    // formik.setValues(initialValues);
    // formik.setTouched({});
    // formik.setErrors({});
  };

  useEffect(() => {
    getFgReportDownload(
      dateRange[1] !== null
        ? addDays(dateRange[1], 1)?.toISOString()
        : new Date().toISOString(),
      dateRange[0] !== null
        ? addDays(dateRange[0], 1)?.toISOString()
        : customDate,
      pageNo,
      rowsPerPage,
      searchObject,
      jwtToken,
    );
  }, [customDate, dateRange]);

  useEffect(() => {
    let tempFinishedGoods = [];
    let data = getFgReportReducer.picklistAgeing.data
      ? getFgReportReducer.picklistAgeing.data
      : [];
    setLoading(getFgReportReducer.loading);
    setPaginationObj(getFgReportReducer?.picklistAgeing?.pagination);
    data?.map((finishedGoods) => {
      const formatDate = new Date(finishedGoods.startDate);
      let len = desLength;
      const finishedGoodsObject = {
        fgModelCode: finishedGoods.fgModelCode,
        fgType: finishedGoods.fgType,
        documentNumber: finishedGoods.documentNumber,
        vin: finishedGoods.vin,
        serialNumber: finishedGoods.serialNumber,
        // desciption: finishedGoods.desciption,

        // desciption: (
        //   <span style={{ display: "flex" }}>
        //     <MDTypography
        //       variant="h6"
        //       fontWeight="regular"
        //       style={{ fontSize: "14px" }}
        //     >
        //       {finishedGoods.desciption
        //         ? finishedGoods.desciption.substring(0, len)
        //         : ""}
        //     </MDTypography>
        //     {finishedGoods?.desciption?.length > 35 && (
        //       <Tooltip
        //         title={finishedGoods.desciption}
        //         style={{ marginLeft: "0.1rem" }}
        //       >
        //         ...
        //       </Tooltip>
        //     )}
        //   </span>
        // ),
        desciption: (
          <span style={{ display: "flex", alignItems: "center" }}>
            {finishedGoods?.desciption?.length > 35 ? (
              <Tooltip
                title={finishedGoods.desciption}
                style={{ cursor: "pointer" }}
              >
                <MDTypography
                  variant="h6"
                  fontWeight="regular"
                  style={{ fontSize: "14px" }}
                >
                  {finishedGoods.desciption.substring(0, len)}
                </MDTypography>
              </Tooltip>
            ) : (
              <MDTypography
                variant="h6"
                fontWeight="regular"
                style={{ fontSize: "14px" }}
              >
                {finishedGoods.desciption}
              </MDTypography>
            )}
            {finishedGoods?.desciption?.length > 35 && (
              <span style={{ marginLeft: "0.1rem" }}>...</span>
            )}
          </span>
        ),
        workOrder: finishedGoods.workOrder,
        // createdDate: format(
        //   addMinutes(formatDate, formatDate.getTimezoneOffset()),
        //   "dd/MM/yyyy hh:mm aaa"
        // ),
        startDate: finishedGoods.startDate,
        status: (
          <button
            className={
              (finishedGoods.status === 0 && `status-info`) ||
              (finishedGoods.status === 1 && `status-created`) ||
              (finishedGoods.status === 2 && `status-warning`) ||
              (finishedGoods.status === 3 && `status-success`) ||
              (finishedGoods.status === 4 && `status-info`) ||
              (finishedGoods.status === 5 && `status-success`)
            }
            // className={
            //   (finishedGoods.status === 0 && `status-created`) ||
            //   (finishedGoods.status === 1 && `status-warning`) ||
            //   (finishedGoods.status === 2 && `status-info`) ||
            //   (finishedGoods.status === 3 && `status-info`) ||
            //   (finishedGoods.status === 4 && `status-info`) ||
            //   (finishedGoods.status === 5 && `status-success`)
            // }
            style={{ width: "5.5rem" }}
          >
            {(finishedGoods.status === 0 && `In Progress`) ||
              (finishedGoods.status === 1 && `Created`) ||
              (finishedGoods.status === 2 && `In Yard`) ||
              (finishedGoods.status === 3 && `Dispatched`) ||
              (finishedGoods.status === 4 && `Putaway`) ||
              (finishedGoods.status === 5 && `Delivered`)}
          </button>
        ),
        status2:
          (finishedGoods.status === 0 && `In Progress`) ||
          (finishedGoods.status === 1 && `Created`) ||
          (finishedGoods.status === 2 && `In Yard`) ||
          (finishedGoods.status === 3 && `Dispatched`) ||
          (finishedGoods.status === 4 && `Putaway`) ||
          (finishedGoods.status === 5 && `Delivered`),
      };
      tempFinishedGoods.push(finishedGoodsObject);
    });
    viewAccess && setState({ ...state, rows: tempFinishedGoods });
  }, [getFgReportReducer]);

  const [download, setDownload] = useState(true);
  useEffect(() => {
    let tempFinishedGoods = [];
    let data = getFgReportDownloadReducer.picklistAgeing.data
      ? getFgReportDownloadReducer.picklistAgeing.data
      : [];

    // setLoading(getFgReportDownloadReducer.loading);
    setPaginationObj(getFgReportDownloadReducer?.picklistAgeing?.pagination);
    data?.map((finishedGoods) => {
      const formatDate = new Date(finishedGoods.startDate);

      const finishedGoodsObject = {
        fgModelCode: finishedGoods.fgModelCode,
        fgType: finishedGoods.fgType,
        documentNumber: finishedGoods.documentNumber,
        vin: finishedGoods.vin,
        serialNumber: finishedGoods.serialNumber,
        desciption: finishedGoods.desciption,
        workOrder: finishedGoods.workOrder,
        createdDate: format(
          addMinutes(formatDate, formatDate.getTimezoneOffset()),
          "dd/MM/yyyy hh:mm aaa",
        ),
        startDate: finishedGoods.startDate,
        status: (
          <button
            className={
              (finishedGoods.status === 0 && `status-created`) ||
              (finishedGoods.status === 1 && `status-warning`) ||
              (finishedGoods.status === 2 && `status-info`) ||
              (finishedGoods.status === 3 && `status-info`) ||
              (finishedGoods.status === 4 && `status-info`) ||
              (finishedGoods.status === 5 && `status-success`)
            }
            style={{ width: "5.5rem" }}
          >
            {(finishedGoods.status === 0 && `Created`) ||
              (finishedGoods.status === 1 && `Released`) ||
              (finishedGoods.status === 2 && `Picking`) ||
              (finishedGoods.status === 3 && `Picked`) ||
              (finishedGoods.status === 4 && `Putaway`) ||
              (finishedGoods.status === 5 && `Delivered`)}
          </button>
        ),
        status2:
          (finishedGoods.status === 0 && `In Progress`) ||
          (finishedGoods.status === 1 && `Created`) ||
          (finishedGoods.status === 2 && `In Yard`) ||
          (finishedGoods.status === 3 && `Dispatched`) ||
          (finishedGoods.status === 4 && `Putaway`) ||
          (finishedGoods.status === 5 && `Delivered`),
      };
      tempFinishedGoods.push(finishedGoodsObject);
    });
    setDownload(tempFinishedGoods);
  }, [getFgReportDownloadReducer]);

  const headers = [
    {
      label: "fgModelCode",
      key: "fgModelCode",
    },
    {
      label: "fgType",
      key: "fgType",
    },
    { label: "vin", key: "vin" },
    { label: "description", key: "desciption" },
    { label: "serialNumber", key: "serialNumber" },
    { label: "workOrder", key: "workOrder" },
    { label: "Status", key: "status2" },
    { label: "createdDate", key: "createdDate" },
  ];

  const csvLink = {
    filename: "FG Related Report.csv",
    headers: headers,
    data: download,
  };

  const handleMovementTypeChange = (selectedOption) => {
    setMovementTypeSelected(selectedOption);
    setparameterSelected("");
  };

  const [createdActivityOptions, setCreatedActivityOptions] = useState([]);

  useEffect(() => {
    let tempCreatedActivityOptions = [];
    let data = getMovementByDocReducer.documents
      ? getMovementByDocReducer.documents
      : [];
    data.map((activity) => {
      tempCreatedActivityOptions.push({
        label: activity.mvtCode,
        value: activity.mvtId,
      });
    });
    setCreatedActivityOptions(tempCreatedActivityOptions);
  }, [getMovementByDocReducer]);

  const handleParameterChange = (selectedOption) => {
    setparameterSelected(selectedOption);
  };

  const [parameterOptions, setParameterOptions] = useState([]);

  useEffect(() => {
    let tempCreatedActivityOptions = [];
    let data = getFGModalReducer.documents ? getFGModalReducer.documents : [];
    data.map((activity) => {
      tempCreatedActivityOptions.push({
        label: activity.ageingValue,
        value: activity.ageingValue,
      });
    });
    setParameterOptions(tempCreatedActivityOptions);
  }, [getFGModalReducer]);

  const handleDocumentTypeChange = (selectedOption) => {
    setDocumentTypeSelected(selectedOption);
    setMovementTypeSelected("");
    setparameterSelected("");
  };

  const dateRangeOptions = [
    { label: "Last 7 Days", value: 7 },
    { label: "Last 30 Days", value: 30 },
    { label: "Last 3 Months", value: 90 },
    { label: "Custom date Range", value: "Custom date Range" },
  ];

  const [documentTypeOptions, setDocumentTypeOptions] = useState([]);

  useEffect(() => {
    let tempDocumentTypeOptions = [];
    let data = getFGTypeReducer.ageingParameter.data
      ? getFGTypeReducer.ageingParameter.data
      : [];
    data.map((document) => {
      tempDocumentTypeOptions.push({
        label: document.documentName,
        value: document.documentId,
      });
    });
    setDocumentTypeOptions(tempDocumentTypeOptions);
  }, [getFGTypeReducer]);

  const subModuleId = "ed6d6e31-3de3-49f9-a443-52854062de6b";

  let dynamicColumnDetails = cookies.get("dynamic-column-data");
  let userId = loginDetails.data.userId;
  let hiddenColumsDetails = cookies.get("hidden-column-data");

  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [dynamicColumnData, setDynamicColumnData] = useState("");
  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);
      getFgReport(pageNo, rowsPerPage, searchObject, jwtToken);

      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <MDBox pt={0} pb={3} mb={-2.5}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox color="text" p={0} px={2} mt={0} mb={-2}>
                <DownloadDataButton
                  type="button"
                  variant="outlined"
                  color="success"
                  iconOnly
                  tooltip="Download All Data"
                  style={{ borderRadius: "5px" }}
                  size="small"
                  onClick={handleCreateCircularModal}
                >
                  <Icon>download</Icon>
                </DownloadDataButton>
              </MDBox>

              <Modal
                open={createCircularModal}
                onClose={handleCreateCloseCircularModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={style} style={{ zIndex: 0 }}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h5" fontWeight="medium" flexGrow={1}>
                      Download Report
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCreateCloseCircularModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    {/* <MDBox
                      component="form"
                      role="form"
                      onSubmit={formik.handleSubmit}
                    > */}
                    <MDBox style={{ marginRight: "5px", marginBottom: "10px" }}>
                      <MDTypography variant="h6" style={{ fontWeight: 500 }}>
                        Date Range
                      </MDTypography>
                      <Select
                        // isClearable
                        placeholder="Choose One..."
                        className="select-css-for-filter"
                        maxMenuHeight={130}
                        options={dateRangeOptions}
                        value={selectedDateRange}
                        onChange={handleDateRangeChange}
                      />
                    </MDBox>
                    {selectedDateRange?.value === "Custom date Range" && (
                      <MDBox
                        // width={{ xs: "125px", lg: "700px" }}
                        style={{ marginRight: "5px" }}
                      >
                        <MDTypography variant="h6">
                          Custom Date Range
                        </MDTypography>

                        <DatePicker
                          className="form-control"
                          dateFormat="dd/MM/yyyy"
                          placeholderText="Select date range"
                          onChange={(date) => setDateRange(date)}
                          isClearable={true}
                          startDate={startDate}
                          endDate={endDate}
                          selectsRange={true}
                          popperPlacement="right-end"

                          // withPortal
                        />

                        {/* {formik.touched.startDate &&
                            formik.errors.startDate && (
                              <TextError msg={formik.errors.startDate} />
                            )} */}
                      </MDBox>
                    )}
                    {/* <MDBox>
                        <Collapse in={isError}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsError(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsg}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccess}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsSuccess(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Circular Created successfully
                          </Alert>
                        </Collapse>
                      </MDBox> */}
                    <MDBox mt={3}>
                      {((selectedDateRange?.value === "Custom date Range" &&
                        dateRange[0] !== null) ||
                        selectedDateRange) &&
                        download.length < 1 && (
                          <TextError msg="No data found" />
                        )}
                      {(selectedDateRange?.value === "Custom date Range" &&
                        dateRange[0] === null) ||
                      download.length < 1 ||
                      !selectedDateRange ? (
                        <MDButton
                          color="success"
                          fullWidth
                          type="button"
                          disabled
                        >
                          Submit
                        </MDButton>
                      ) : (
                        <CSVLink
                          {...csvLink}
                          onClick={() => {
                            // Close modal after 2 seconds
                            setTimeout(() => {
                              handleCreateCloseCircularModal();
                            }, 1000); // 2000ms = 2 seconds
                          }}
                        >
                          <MDButton color="success" fullWidth type="button">
                            Submit
                          </MDButton>
                        </CSVLink>
                      )}
                    </MDBox>
                  </MDBox>
                  {/* </MDBox> */}
                </MDCard>
              </Modal>
              <Modal
                open={openCreateColumnReorderModal}
                onClose={handleCloseCreateColumnReorderModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ backdropFilter: "blur(5px)" }}
              >
                <MDCard sx={styleForColumnReorder}>
                  <MDTypography>Are you sure you want to submit?</MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      style={{ width: "10rem", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseCreateColumnReorderModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ width: "10rem", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={handleDynamicColumn}
                      // disabled={denyButtonName === "Please wait..."}
                    >
                      Submit
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessColumnReorder}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Data updated successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorColumnReorder}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {isErrorMsgForColumnReorder}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>

              <MDBox pt={3}>
                {/* {!loading ? ( */}

                {loadingForDynamicColumn && (
                  <DataTable
                    table={{ columns, rows }}
                    isSorted={true}
                    tableSearch={true}
                    entriesPerPage={{
                      defaultValue: 5,
                      entries: [5, 10, 15, 20, 25, 30],
                    }}
                    showTotalEntries={true}
                    noEndBorder
                    options={{ draggable: false }}
                    serverSidePagination={true}
                    paginationObj={paginationObj}
                    pageNoValue={pageNo}
                    rowsPerPageValue={rowsPerPage}
                    pageNoProp={importPageNo}
                    rowsPerPageProp={importRowsPerPage}
                    searchProp={importSearch}
                    loading={loading}
                    hideColumns={hiddenColumsDetails}
                    visibleColumns2={dynamicColumnData?.visibleFields}
                    dynamicColumnData={dynamicColumnData}
                    handleOpenCreateColumnReorderModal={
                      handleOpenCreateColumnReorderModal
                    }
                    subModuleId={subModuleId}
                    userId={userId}
                  />
                )}
                {/* ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      marginTop: "100px",
                      marginBottom: "100px",
                    }}
                  >
                    <CircularProgress color="info" />
                  </div>
                )} */}
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {loading && (
        <Backdrop
          sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      )}

      <ToastContainer />
    </DashboardLayout>
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    getMovementByDocReducer: state.getMovementByDocReducer,
    getAcnReducer: state.getAcnReducer,
    getFGTypeReducer: state.getFGTypeReducer,
    getFgReportReducer: state.getFgReportReducer,
    getFGModalReducer: state.getFGModalReducer,
    getFgReportDownloadReducer: state.getFgReportDownloadReducer,

    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getCreatedActivity: (documentType, jwtToken) =>
      dispatch(getCreatedActivity(documentType, jwtToken)),
    getMovementByDocumentId: (documentTypeSelected, jwtToken) =>
      dispatch(getMovementByDocumentId(documentTypeSelected, jwtToken)),
    getAcn: (jwtToken) => dispatch(getAcn(jwtToken)),
    getDocumentType: (jwtToken) => dispatch(getDocumentType(jwtToken)),
    getAgeingParameter: (jwtToken) => dispatch(getAgeingParameter(jwtToken)),
    getPicklistAgeing: (
      documentTypeSelected,
      movementTypeSelected,
      parameterSelected,
      jwtToken,
    ) =>
      dispatch(
        getPicklistAgeing(
          documentTypeSelected,
          movementTypeSelected,
          parameterSelected,
          jwtToken,
        ),
      ),
    getFgReport: (pageNo, rowsPerPage, searchObject, jwtToken) =>
      dispatch(getFgReport(pageNo, rowsPerPage, searchObject, jwtToken)),
    getFgReportDownload: (
      startDate,
      endDate,
      pageNo,
      rowsPerPage,
      searchObject,
      jwtToken,
    ) =>
      dispatch(
        getFgReportDownload(
          startDate,
          endDate,
          pageNo,
          rowsPerPage,
          searchObject,
          jwtToken,
        ),
      ),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(FGRelatedReport);
